import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ocr-plus-txt-phrase',
  templateUrl: './ocr-plus-txt-phrase.component.html',
  styleUrls: ['./ocr-plus-txt-phrase.component.css']
})
export class OcrPlusTxtPhraseComponent {
  @Input() item: any;

  
  getTextLines() {
    return this.item.text.split('\n')
  }
}
